/**
 * Atelier Royal: tabs.js: <ar-tabs> (WAI-ARIA tabs, automatic activation).
 * Load it from any section that renders tabs:
 *   <script src="{{ 'tabs.js' | asset_url }}" type="module" defer></script>
 * Markup: a [role="tablist"] of [role="tab"] buttons (aria-controls → panel id,
 * aria-selected, roving tabindex) and [role="tabpanel"] panels (non-selected ones `hidden`
 * in Liquid). Arrow keys, Home and End move between tabs. Emits `ar:tabs:change`.
 */
class ARTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = [...this.querySelectorAll('[role="tab"]')].filter((tab) => tab.closest('ar-tabs') === this);
    if (!this.tabs.length || this.dataset.arReady) return;
    this.dataset.arReady = 'true';
    this.tabs.forEach((tab) => tab.addEventListener('click', () => this.select(tab)));
    this.addEventListener('keydown', (event) => {
      const index = this.tabs.indexOf(event.target);
      if (index < 0) return;
      const last = this.tabs.length - 1;
      const next = { ArrowRight: index + 1, ArrowDown: index + 1, ArrowLeft: index - 1, ArrowUp: index - 1, Home: 0, End: last }[event.key];
      if (next === undefined) return;
      event.preventDefault();
      this.select(this.tabs[(next + this.tabs.length) % this.tabs.length], true);
    });
  }

  select(tab, focus = false) {
    this.tabs.forEach((t) => {
      const selected = t === tab;
      t.setAttribute('aria-selected', String(selected));
      t.tabIndex = selected ? 0 : -1;
      const panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) panel.hidden = !selected;
    });
    if (focus) tab.focus();
    this.dispatchEvent(new CustomEvent('ar:tabs:change', { bubbles: true, detail: { tab } }));
  }
}
if (!customElements.get('ar-tabs')) customElements.define('ar-tabs', ARTabs);
